import React, {Component, useState} from 'react';

import {
    Button,
    Search, Checkbox
} from "carbon-components-react";

export default class extends Component {

    state = {
        form: {
            search: "",
            exactPh: false
        }
    };

    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);

    }

    componentDidMount() {
        let {form} = this.props;
        this.setState({
            form: {
                search: typeof form.search != "undefined" ? form.search : "",
                exactPh: typeof form.exactPh != "undefined" ? form.exactPh : true
            }
        })
    }

    handleSubmit = async (e) => {
        this.props.onSubmitForm(this.state.form);
    }

    handleClear = e => {
        this.setState(prevState => ({
            form: {...prevState.form, 'search': ""}
        }));
    };


    handleChange = e => {
        e.preventDefault();
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {...prevState.form, [name]: value}
        }));
    };


    handleKeyUp = e => {
        e.preventDefault();
        if (e.key === 'Enter') {
            const {name, value} = e.target;
            this.setState(prevState => ({
                form: {...prevState.form, [name]: value}
            }));
            this.props.onSubmitForm(this.state.form);
        }
    };

    render() {


        return (
            <>
                <div style={{paddingTop: "60px"}}>
                    <p style={{paddingBottom: "20px"}}>
                        Search for information processed by the Intelligent Journey solution
                    </p>
                    <div className={"bx--row"}>
                        <div className="bx--col-md-4">

                            <Search
                                id="search"
                                name="search"
                                placeHolderText="Search"
                                value={this.state.form.search}
                                onInput={this.handleChange}
                                onKeyUp={this.handleKeyUp}
                                labelText={""}
                                onClear={(evt) => {
                                    this.setState(prevState => ({
                                        form: {
                                            ...prevState.form,
                                            'search': ""
                                        }
                                    }))
                                }}
                            />

                        </div>
                        <div>
                            <Button onClick={this.handleSubmit}>Search</Button>
                        </div>
                    </div>
                    <div className={"bx--row"}>
                        <div className="bx--col-md-4  d-flex flex-row-reverse">
                            <fieldset>
                                <Checkbox checked={this.state.form.exactPh} labelText="Frase Exata" id="checked"
                                          onChange={(evt) => {
                                              this.setState(prevState => ({
                                                  form: {
                                                      ...prevState.form,
                                                      'exactPh': !this.state.form.exactPh
                                                  }
                                              }))
                                          }}/>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
